import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react'
import AuthContext from '../../../auth/AuthContext';
import { useLocation, useParams } from 'react-router-dom';
import FAQService from '../../../services/FAQService';
import AlertService from '../../../services/AlertService';
import { Skeleton } from 'primereact/skeleton';
import { FaInfoCircle, FaMinusSquare } from 'react-icons/fa';
import { FaPlusSquare } from 'react-icons/fa';
import { FaSearch } from 'react-icons/fa';

const FaqDetail = () => {
  const { state } = useLocation();
  const { faqType } = useParams();
  const [loading, setLoading] = useState(false);
  const [faqs, setFAQs] = useState([]);
  const [filteredFAQs, setFilteredFAQs] = useState([]);
  const [activeIndex, setActiveIndex] = useState();
  const authContext = useContext(AuthContext);
  const [searchValue, setSearchValue] = useState('');

const loadFAQs = useCallback(async (signal) => { 
    setLoading(true);
    setSearchValue('');
    try {
      const data = await FAQService.GetAll(
        state?.id,
        authContext,
        signal 
      );

      if (signal?.aborted) return; 

      if (data.isSuccess) {
        setFAQs(data.data);
        setFilteredFAQs(data.data);
        setSearchValue('');
      } else {
        AlertService.error(data.errorMessage);
      }
    } catch (err) {
      if (err.name === "AbortError") return; 
    } finally {
      if (!signal?.aborted) setLoading(false); 
    }
  }, [authContext, state?.id]);

useEffect(() => {
    const controller = new AbortController(); 
    loadFAQs(controller.signal);
    return () => controller.abort();
  }, [loadFAQs]);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSubmit = useCallback(() => {
    setFilteredFAQs(() => {
      return faqs.filter(f => f.question.toLowerCase().indexOf(searchValue) !== -1);
    });
  }, [faqs, searchValue]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      handleSubmit();
    }, 100);
  }, [handleSubmit, searchValue]);

  return (
    <Fragment>
        <div className="d-flex flex-wrap align-items-center mt-3 px-3">
      <div className="text-capitalize pb-2 flex-grow-1 flex-shrink-1" style={{ minWidth: '120px' }}>
        {faqType.replace(/-/g, ' ')}
      </div>
      <div
        className="ms-auto me-3 flex-grow-0 flex-shrink-1"
        style={{ maxWidth: '400px', width: '100%', minWidth: '200px' }}
      >
        <div className="position-relative mb-3">
          <div
            className="position-absolute top-50 start-0 translate-middle-y ps-3"
            style={{ pointerEvents: 'auto' }}
          >
            <FaSearch
              className="text-muted cursor-pointer"
              onClick={handleSubmit}
              size={18}
              aria-label="Search"
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            />
          </div>
          <input
            type="text"
            value={searchValue}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            className="form-control ps-5 custom-input-color py-2"
            placeholder="Search..."
            style={{
              paddingLeft: '2.5rem',
              paddingRight: '1rem',
              paddingTop: '0.5rem',
              paddingBottom: '0.5rem',
              fontSize: '1rem',
            }}
          />
        </div>
      </div>
    </div>
      <div className="">
        {loading ? (
          Array.from({ length: 8 }).map((_, idx) => (
            <div key={idx} className='col-12 p-2'>
              <Skeleton width='100%' height='5rem'></Skeleton>
            </div>
          ))
        ) : (
          <div className="accordion-wrapper">
            {filteredFAQs && filteredFAQs.length > 0 && filteredFAQs.map((item, index) =>
              <div key={index} className={`accordion-item border-0  mt-0 shadow-sm ${activeIndex === index ? 'active' : ''}`} >
                <button
                  className={`accordion-header ${activeIndex === index ? 'active' : ''}`}
                  onClick={() => toggleAccordion(index)}
                >
                  <div className="accordion-icon-wrapper">
                      <FaInfoCircle 
                                              size={20}
                                                color={activeIndex === index? "#007bff" : "#6c757d"}
                                                style={{ cursor: "pointer" }}
                                              />
                  </div>
                  <span className={`accordion-title ${activeIndex === index ? 'active' : ''}`}>{item.question}</span>
                  <div className={`accordion-toggle ${activeIndex === index ? 'active' : ''}`}>
                    {activeIndex === index ? (<FaMinusSquare  size={25} />) : (<FaPlusSquare size={25} />)}
                  </div>
                </button>

                <div className={`accordion-content ${activeIndex === index ? 'open' : ''}`}>
                  <div className="accordion-content-inner">
                    {item.answer}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Fragment >

  )
}

export default FaqDetail;